import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {
  PRODUCT_REVIEW_BRAND_INFORMATION_SECTION,
  PRODUCT_REVIEW_BRAND_MULTILANGUAGE_SECTION,
} from '../productReviewDataMap'

export const BrandSection = () => {
  return (
    <ProductReviewSection title="Brand Information" icon="info">
      <ProductReviewData
        sections={[PRODUCT_REVIEW_BRAND_INFORMATION_SECTION, PRODUCT_REVIEW_BRAND_MULTILANGUAGE_SECTION]}
      />
    </ProductReviewSection>
  )
}
